import React from 'react';
import style from './style.module.scss';

type Props = {
    children: React.ReactNode;
    title?: string;
    id?: string;
}

const InfoParagraph = ({ children, title, id }: Props) => {
    
    return (
        <div className={style.infoParagraph} id={id}>
            {title && (
                <div className={style.infoParagraphTitle}>{title}</div>
            )}
            <div>
                {children}
            </div>
        </div>
    );
}

export default InfoParagraph;